import { Country } from '../types/game';

export function getCountryName(language: string, country: Country) {
  return country?.names?.[language] || country?.names?.en || country.name;
}
